module.exports = __webpack_public_path__ + "static/img/img-shu.671f1cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-shu.png
// module id = lfWI
// module chunks = 0